import { observer, Observer } from "mobx-react";
import React from "react";

export const ObserverList = observer(({ list, render }) => list && list.map((item, i) => render(item, i)));

export const AutoObserverList = observer(({ list, render, getItemKey }) => list && list.map((item, i) => <Observer key={getItemKey(item)}>{() => render(item, i)}</Observer>));